var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('data-table',{attrs:{"cols":_vm.cols,"items":_vm.sortedItems,"height":_vm.height},on:{"sort":_vm.onSort}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }